/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Well_Be_In_Touch_SoonInputs */

const en_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll be in touch soon.`)
};

const es_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos pondremos en contacto pronto.`)
};

const fr_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous vous contacterons bientôt.`)
};

const de_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir melden uns bald.`)
};

const ja_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まもなくご連絡いたします。`)
};

const zh_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们将很快与您联系。`)
};

const ar_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنتواصل معك قريباً.`)
};

const id_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami akan segera menghubungi Anda.`)
};

const it_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti contatteremo presto.`)
};

const ru_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы скоро с вами свяжемся.`)
};

const pt_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entraremos em contato em breve.`)
};

const ko_well_be_in_touch_soon = /** @type {(inputs: Well_Be_In_Touch_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`곧 연락드리겠습니다.`)
};

/**
* | output |
* | --- |
* | "We'll be in touch soon." |
*
* @param {Well_Be_In_Touch_SoonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const well_be_in_touch_soon = /** @type {((inputs?: Well_Be_In_Touch_SoonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Well_Be_In_Touch_SoonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_well_be_in_touch_soon(inputs)
	if (locale === "es") return es_well_be_in_touch_soon(inputs)
	if (locale === "fr") return fr_well_be_in_touch_soon(inputs)
	if (locale === "de") return de_well_be_in_touch_soon(inputs)
	if (locale === "ja") return ja_well_be_in_touch_soon(inputs)
	if (locale === "zh") return zh_well_be_in_touch_soon(inputs)
	if (locale === "ar") return ar_well_be_in_touch_soon(inputs)
	if (locale === "id") return id_well_be_in_touch_soon(inputs)
	if (locale === "it") return it_well_be_in_touch_soon(inputs)
	if (locale === "ru") return ru_well_be_in_touch_soon(inputs)
	if (locale === "pt") return pt_well_be_in_touch_soon(inputs)
	return ko_well_be_in_touch_soon(inputs)
});